import { useQuery } from '@tanstack/react-query';
import { pb } from '@/core/api';

export function useSupportLink(): string | null {
  const { data } = useQuery({
    queryKey: ['support-link'],
    queryFn: async (): Promise<string> => {
      const r = await pb.send('/api/config/public', { method: 'GET' });
      return (r['support_whatsapp_link'] as string) ?? '';
    },
    staleTime: 300_000,
  });
  return data || null;
}
